import React from 'react';
import ReactDOM from 'react-dom';

// third party
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

// project imports
import { pca } from 'libs/pca';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './libs/day';
import './libs/i18n';
import './libs/numeral';

import App from './App';

// style + assets
import 'assets/scss/style.scss';

pca.initialize().then(() => {
    const accounts = pca.getAllAccounts();

    if (accounts.length > 0) {
        pca.setActiveAccount(accounts[0]);
    }

    pca.addEventCallback((event: EventMessage) => {
        const payload = event.payload as AuthenticationResult;
        if (event.eventType === EventType.LOGIN_SUCCESS && payload.account) {
            pca.setActiveAccount(payload.account);
        }
    });

    ReactDOM.render(
        <React.StrictMode>
            <MsalProvider instance={pca}>
                <App />
            </MsalProvider>
        </React.StrictMode>,
        document.getElementById('root')
    );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
